import React from "react";
import Logo from "@/Components/Logo";
import Link from "@/Layouts/Link";

const MainLogo = ({href = '/', className = 'headerMain__logo'}) => {
    return (
        <Link href={href} className={className}>
            <Logo />
        </Link>
    );
}

export default MainLogo;
